import React, { Component } from 'react';
import PropTypes from 'prop-types';
import tableSort from 'services/tableSort';

// Components
import TableHeader from 'components/tableHeader';
import TableRow from 'components/tableRow';

// Styles
import styles from './table.scss';

export default function (RowComponent = TableRow) {
  class Table extends Component {
    constructor() {
      super();
      this.state = {
        sort: {
          column: 0,
          dir: 'ASC', // alternative is 'DESC'
        },
      };

      this.changeSort = this.changeSort.bind(this);
      this.setScrollPosition = this.setScrollPosition.bind(this);
    }

    componentDidMount() {
      this.setScrollPosition(1);
    }

    /**
     * Sets the scroll position of this.scroller given the percent scrolled
     * it should be.
     * @param {number} percent Number from 0 to 1.
     */
    setScrollPosition(percent = 1) {
      if (this.scroller) {
        this.scroller.scrollLeft =
          percent * (this.scroller.scrollWidth - this.scroller.clientWidth);
      }
    }

    changeSort(sort) {
      const newSort = sort;
      if (this.state.sort.column === sort.column) {
        newSort.dir = ('ASC' === this.state.sort.dir) ? 'DESC' : 'ASC';
      } else {
        newSort.dir = 'DESC';
      }
      this.setState({ sort: newSort });
    }

    render() {
      const {
        rowData,
        columns,
        isTwoCol,
        renderType,
      } = this.props;
      const { sort } = this.state;

      return (
        <div className={isTwoCol ? styles.narrowWrapper : styles.wrapper}>
          <div
            className={isTwoCol ? '' : styles.scroller}
            ref={(scroller) => { this.scroller = scroller; }}
          >
            <table className={styles.table}>
              <TableHeader
                activeSort={sort}
                columns={columns}
                changeSort={this.changeSort}
                isTwoCol={isTwoCol}
              />
              <tbody className={styles.body}>
                {rowData
                  .sort(tableSort(this.state.sort))
                  .map((datum) => (
                    <RowComponent
                      {...datum}
                      key={datum.rowId}
                      isTwoCol={isTwoCol}
                      renderType={renderType}
                    />
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }

  Table.defaultProps = {
    isTwoCol: false,
    renderType: '',
  };

  Table.propTypes = {
    columns: PropTypes.arrayOf(
      PropTypes.shape({
        idx: PropTypes.number.isRequired,
        colId: PropTypes.string.isRequired,
        label: PropTypes.string,
        fixed: PropTypes.oneOf(['left', 'right']),
      })
    ).isRequired,
    renderType: PropTypes.string,
    rowData: PropTypes.arrayOf(
      PropTypes.shape({
        rowId: PropTypes.string.isRequired,
        pin: PropTypes.bool.isRequired,
        data: PropTypes.arrayOf(
          PropTypes.shape({
            idx: PropTypes.number.isRequired,
            fixed: PropTypes.oneOf(['left', 'right']),
            align: PropTypes.oneOf(['right', 'center', 'left']),
            formattedValue: PropTypes.string.isRequired,
          })
        ).isRequired,
      })
    ).isRequired,
    isTwoCol: PropTypes.bool,
  };

  return Table;
}



// WEBPACK FOOTER //
// ./app/components/table/index.js